import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngUploadFileComponent } from './kng-upload-file.component';
import { KngUploadFileService } from './kng-upload-file.service';
import { SharedModuleLib } from '../../shared/shared.module';
import { KngLoaderModule } from '../loader';

@NgModule({
	declarations: [KngUploadFileComponent],
	imports: [ CommonModule, SharedModuleLib, KngLoaderModule ],
	exports: [KngUploadFileComponent],
	providers: [KngUploadFileService]
})
export class KngUploadFileModule {}
